import { updateRaiseWorkOrderDetails } from "actions/updateRaiseWorkOrderDetails";
import { updateViewWorkOrderPageOrigination } from "actions/updateViewWorkOrderPageOrigination";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import IRaiseWorkOrderDetails from "interfaces/IRaiseWorkOrderDetails";
import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";
import { useStateMachine } from "little-state-machine";
import { IsNonSiteUser } from "modules/CheckPermissions";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const WorkOrderReferenceTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrder = { props };
  const navigate = useNavigate();
  const { state } = useStateMachine();

  const { actions } = useStateMachine({
    updateRaiseWorkOrderDetails,
    updateViewWorkOrderPageOrigination
  });

  const navigateToRaiseWorkOrder = () => {
    const raiseWorkOrderDetails : IRaiseWorkOrderDetails = {
      containerId: workOrder.props.containerId!,
      containerType: `${workOrder.props.containerWasteType} - ${workOrder.props.containerSize}`,
      hwrcSiteName: workOrder.props.hwrcSiteName,
      regionId: workOrder.props.regionId,
      regionName: workOrder.props.regionName,
      pageOrigination: RoutePathsEnum.WorkOrders
    };

    actions.updateRaiseWorkOrderDetails(raiseWorkOrderDetails);
    navigate(RoutePathsEnum.WorkOrderRaise);
  };

  const navigateToViewWorkOrder = () => {
    actions.updateViewWorkOrderPageOrigination(RoutePathsEnum.WorkOrders);
    navigate(`${RoutePathsEnum.WorkOrderView}/${workOrder.props.workOrderReference}`);
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      {workOrder.props.workOrderReference
      && (
        <span>
          <Button
            onClick={navigateToViewWorkOrder}
            className="btn-link"
          >
            {workOrder.props.workOrderReference}

          </Button>
        </span>
      ) }

      {!workOrder.props.workOrderReference && IsNonSiteUser(state.userRole!)
      && (
        <Button
          variant="primary"
          className="px-4"
          onClick={navigateToRaiseWorkOrder}
          data-testid={`btn-new-work-order-${workOrder.props.containerId}`}
          aria-label={`Add new work order for container ${workOrder.props.containerWasteType}`}
        >
          Add New
        </Button>
      )}
    </div>
  );
};
export default WorkOrderReferenceTemplate;
